module.exports = __webpack_public_path__ + "img/play.06417ac4.svg";